import React from 'react';
import { testimonials } from '../../data/company';
import { SectionHeading } from '../ui/SectionHeading';
import { SampleTag } from '../ui/SampleTag';
export function Testimonials() {
  return <section className="bg-ivory py-24 md:py-32" data-id="element-305" data-mp="2mr6c53or9wro">
      <div className="container-page" data-id="element-306" data-mp="2mrzdfp4y3u2f">
        <SectionHeading kicker="Testimonials" title="In their words." intro="Genuine client and candidate testimonials will be published here once supplied and approved. The entries below are clearly marked placeholders." data-id="element-307" data-mp="2ht4tgjv8rzgq" />
        <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-0 md:divide-x md:divide-line" data-id="element-308" data-mp="3af7efuvccgyn">
          {testimonials.map(t => <figure key={t.role} className="flex flex-col md:px-8 md:first:pl-0 md:last:pr-0" data-id="element-309" data-mp="31gvo7tydzl6q">
              <SampleTag label="Placeholder" className="self-start" data-id="element-310" data-mp="1u2sewq5hr4h6" />
              <span className="mt-6 font-display text-6xl leading-none text-gold" aria-hidden="true" data-id="element-311" data-mp="1u0xqh1v0gu8c">
                “
              </span>
              <blockquote className="mt-2 font-display text-2xl leading-snug text-ink" data-id="element-312" data-mp="2z9zhvct8ra9v">{t.quote}</blockquote>
              <figcaption className="mt-auto pt-6 text-sm text-muted" data-id="element-313" data-mp="349u8rgd0nzux">
                {t.role} — {t.org}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}